module.exports = __webpack_public_path__ + "static/media/hello-article-hero.008da592.jpg";